import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarSparkleOutlinedSize32Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 8c3 4.5 7.5 9 12 12-4.5 3-9 7.5-12 12-3-4.5-7.5-9-12-12 4.5-3 9-7.5 12-12m0 4.068A49.6 49.6 0 0 1 4.068 20 49.6 49.6 0 0 1 12 27.931 49.6 49.6 0 0 1 19.931 20 49.6 49.6 0 0 1 12 12.068"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M25.333 0C27 2.5 29.5 5 32 6.667c-2.5 1.666-5 4.166-6.667 6.666-1.666-2.5-4.166-5-6.666-6.666C21.167 5 23.667 2.5 25.333 0m0 3.926a29 29 0 0 1-2.74 2.74 29 29 0 0 1 2.74 2.74 29 29 0 0 1 2.74-2.74 29 29 0 0 1-2.74-2.74"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
HyperstarSparkleOutlinedSize32Glyph.displayName = 'HyperstarSparkleOutlinedSize32Glyph';
